export const specialDSPNames = {
  tidal: 'Tidal',
  amazon: 'Amazon',
  apple: 'Apple Music',
};
